import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PayloadProps } from "../../core/schema";
import { getLocalStorage } from "../../core/localStorageService";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import BackSecion from "../common/header";
import { Spinner } from "react-bootstrap";
import moment from "moment";

/**
 * Renders Component.
 * @return {StudentAssignments} renders Component.
 */
export default function StudentAssignments() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getStudentFee();
  }, []);
  useEffect(() => {}, []);

  const getStudentFee = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        mobile: user?.student[0]?.mobile,
      },
      method: "POST",
      apiUrl: apiEndpoint.viewAssignemt,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          setData(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="cmmn px-3">
        <Container className="d-flex flex-column height_100vh">
          <BackSecion name="Assignments" navigate_action="/home" />
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}

          {!isLoading &&
            data.length > 0 &&
            data.map((item: any, i: number) => {
              return (
                <Row className="mt-4">
                  <Col xs={12} className="m-auto fee_gry rounded-3 p-3">
                    <Row>
                      <Col xs={8}>
                        <p className="f-14 fw-bold">{item.subject}</p>
                      </Col>
                      <Col xs={5} className="f-12 status_clr">
                        <p className="m-0">Assigned on</p>
                        <div className="fw-bold">
                          {moment(item.date_added).format("DD MMM YYYY")}
                        </div>
                      </Col>
                      <Col xs={5} className="f-12 status_clr">
                        <p className="m-0">Submission</p>
                        <div className="text_blue fw-bold">-</div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              );
            })}
          {!isLoading && data.length === 0 && (
            <Row className="mt-3">
              <Col xs={12} className="text-center">
                No assignments found.
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </>
  );
}
